<template>
  <div>
    <el-row class="title-bar" type="flex" justify="space-between">
      <div class="vertical-center-box">
        <div class="title-h3 mr-r15 vertical-center-box">적용 템플릿 목록</div>
        <el-button class="mr-r4" size="mini" type="secondary" @click="updateTarget" :disabled="isEmpty(selectedImage) || selectedImage.imageId === null">수정하기</el-button>
      </div>
      <div class="vertical-center-box" align="right">
        <w-header-search-button @click="toggleSearchTool"/>
      </div>
    </el-row>
    <el-table-wrapper ref="targetTable" :column-default="columnDefault" :data="tableData" :columns="tableColumns" remote pagination
    :total="total" :show-custom-header="true" :show-search-tool="showSearchTool" @condition-change="loadData">
    </el-table-wrapper>
    <w-target-template-setting-popup ref="targetSlidingPopup" :selected-image="selectedImage" :target-tmpl-list="targetTmplList"
    :origin-target-tmpl-ids="originTargetTmplIds" @reload-data="loadData()"/>
  </div>
</template>

<script>
import cloneDeep from 'lodash/cloneDeep';
import isEmpty from 'lodash/isEmpty';
import { getValueAfterCheckEmpty } from '@/utils/string';
import { columnDefault } from '@/constants/table';
import VirtualServiceSettingAPI from '@/api/settings/virtual/virtual-service-settings';
import WTargetTemplateSettingPopup from '../popup/TargetTemplateSettingPopup';

const defaultFormatter = (row, column, value) => getValueAfterCheckEmpty(value);

export default {
  name: 'WTargetTemplateTable',
  props: {
    selectedImage: {
      type: Object,
    },
  },
  components: {
    WTargetTemplateSettingPopup,
  },
  data() {
    const tableColumns = [
      {
        prop: 'vmName',
        label: '템플릿명',
        searchable: true,
        sortable: true,
        remotePro: 'vm_name',
        formatter: defaultFormatter,
      },
      {
        prop: 'hypervisorTypeName',
        label: '하이퍼바이저',
        searchable: true,
        sortable: true,
        remoteProp: 'bs.basicinfo_subname',
        formatter: defaultFormatter,
      },
      {
        prop: 'virtualcenterName',
        label: '가상화센터명',
        searchable: true,
        sortable: true,
        remoteProp: 'vvc.virtualcenter_name',
        formatter: defaultFormatter,
      },
      {
        prop: 'osName',
        label: '운영체제',
        searchable: true,
        sortable: true,
        remoteProp: 'atv.attr_value',
        formatter: defaultFormatter,
      },
    ];
    return {
      showSearchTool: false,
      tableData: [],
      total: 0,
      tableColumns,
      columnDefault,
      targetTmplList: [],
      originTargetTmplIds: [],
    };
  },
  watch: {
    selectedImage: {
      immediate: true,
      handler(value) {
        if (!isEmpty(value)) {
          this.loadData();
        } else {
          this.tableData = [];
        }
      },
    },
  },
  methods: {
    isEmpty,
    /**
     * 서버 이미지 별 적용 템플릿 목록을 조회한다.
     * @author najongdang
     * @return {[type]} [description]
     */
    loadData() {
      const tableParams = this.$refs.targetTable.getParameter();
      const params = {
        imageId: this.selectedImage.imageId,
        ...tableParams,
      };
      VirtualServiceSettingAPI.getTargetTemplateListByVmsImage(params).then((response) => {
        const successFlag = response.data.success;
        if (successFlag) {
          const result = response.data;
          this.tableData = result.data;
          this.total = result.total;
        }
      });
    },
    updateTarget() {
      const params = {
        imageId: this.selectedImage.imageId,
      };
      VirtualServiceSettingAPI.getTargetTemplateListByVmsImage(params).then((response) => {
        if (response.data.success) {
          const result = response.data.data;
          this.targetTmplList = cloneDeep(result);
          const originTargetTmplIds = [];
          if (this.targetTmplList.length > 0) {
            this.targetTmplList.forEach((tmpl) => {
              if (!originTargetTmplIds.includes(tmpl.vmsObjId)) {
                originTargetTmplIds.push(tmpl.vmsObjId);
              }
            });
          }
          this.originTargetTmplIds = originTargetTmplIds;
          this.$refs.targetSlidingPopup.open();
        }
      });
    },
    toggleSearchTool() {
      this.showSearchTool = !this.showSearchTool;
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/settings/virtual/VirtualService/ServerImageSetting/components/TargetTemplateTable.vue